module.exports = __webpack_public_path__ + "img/globe.316332e8.jpg";